export default {
      id: "admin-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#admin",
      toString: function () {
        return this.url;
      }
    }